module.exports = __webpack_public_path__ + "static/media/gift.d14e9788.svg";